
































































































































































































































































































import {
  Department,
  Employee,
  Forms,
  Questions,
  ResponseQuestion,
} from "@/api";
import { Component, Ref, Vue } from "vue-property-decorator";
import { requiredString, noSpace } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";
import { selfData } from "@/common/role_utils";
import ConfirmationModule from "@/components/confirmationModule/ConfirmationModule.vue";
import PublishDialog from "./PublishDialog.vue";
import draggable from "vuedraggable";
import _ from "lodash";

@Component({
  components: {
    ConfirmationModule,
    draggable,
    PublishDialog,
  },
})
export default class Question extends Vue {
  @Ref("form") readonly form!: VForm;
  formModel = false;
  departmentID = 0;
  question = "";
  alertDepartment = false;
  allowComments = false;
  allowFeedback = false;
  ratingScore = false;
  loading = true;
  companyId = selfData().companyId;
  required_text = [requiredString, noSpace];
  selectEditingQuestion: ResponseQuestion | null = null;
  saving = false;
  deleting = false;
  deleteDialog = false;
  confirmPublish = false;
  publishing = false;
  savingDraft = false;
  isEdit = false;
  employee = 0;

  required_select = (v: string) =>
    (v !== "" && v !== undefined && v != "0") || "Required";

  async created() {
    const formId = this.$route.params.formId;
    this.loading = true;
    if (formId) await this.$store.dispatch("question/fetchQuestions", formId);
    this.$store.dispatch("directory/loadAllEmployees");
    this.loading = false;
  }

  get departments(): Department[] {
    return this.$store.getters["company/departments"]?.map(
      (item: Department) => {
        return {
          ...item,
          header: undefined,
        };
      },
    );
  }

  clearForm() {
    this.selectEditingQuestion = null;
    this.departmentID = 0;
    this.question = "";
    this.alertDepartment = false;
    this.allowComments = false;
    this.allowFeedback = false;
    this.form.reset();
    this.form.resetValidation();
    this.isEdit = false;
    this.employee = 0;
  }

  get questions(): Questions {
    return this.$store.getters["question/questions"];
  }

  set questions(values: Questions) {
    const requestBody = values.map((item, index) => {
      return {
        ...item,
        order: index,
      };
    });

    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.$store.dispatch("question/sortQuestion", { requestBody, formId });
  }

  async submit() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        departmentID: this.departmentID,
        question: this.question,
        alertDepartment: this.alertDepartment,
        allowComment: this.allowComments,
        allowFeedback: this.allowFeedback,
        ratingScore: this.ratingScore,
        assignee: this.employee,
      };

      await this.$store.dispatch("question/addQuestion", {
        requestBody,
        formId,
      });
      this.saving = false;
      this.clearForm();
    }
  }

  async update() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    if (this.form.validate()) {
      this.saving = true;
      const requestBody = {
        id: this.selectEditingQuestion?.id || 0,
        departmentID: this.departmentID,
        question: this.question,
        alertDepartment: this.alertDepartment,
        allowComment: this.allowComments,
        allowFeedback: this.allowFeedback,
        ratingScore: this.ratingScore,
        assignee: this.employee,
      } as ResponseQuestion;

      await this.$store.dispatch("question/updateQuestion", {
        requestBody,
        formId,
      });
      this.saving = false;
      this.clearForm();
    }
  }

  editQuestion(question: ResponseQuestion) {
    this.selectEditingQuestion = question;
    this.departmentID = question.departmentId || 0;
    this.question = question.question;
    this.alertDepartment = question.alertDepartment;
    this.allowComments = question.allowComment;
    this.allowFeedback = question.allowFeedback;
    this.ratingScore = question.ratingScore;
    this.employee = question?.assignee || 0;
    this.isEdit = true;
  }

  checkStandardQuestion(): boolean {
    if (this.selectEditingQuestion) {
      return this.selectEditingQuestion.id <= 0;
    }

    return false;
  }

  async removeQuestion(question: ResponseQuestion) {
    this.selectEditingQuestion = question;
    this.deleteDialog = !this.deleteDialog;
  }

  async confirmRemove() {
    const formId = Number(this.$route.params.formId);
    if (!formId) {
      this.$store.dispatch("alert/warning", "failed to add question");
      return;
    }
    this.deleting = true;
    await this.$store.dispatch("question/removeQuestion", {
      requestBody: this.selectEditingQuestion,
      formId,
    });
    this.clearForm();
    this.deleting = false;
    this.deleteDialog = !this.deleteDialog;
  }

  back() {
    this.$router.back();
  }

  async publish() {
    const formId = Number(this.$route.params.formId);
    const forms = this.$store.getters["question/forms"] as Forms;
    const requestBody = forms.filter(form => form.id === formId);
    if (!formId || !forms || requestBody.length == 0) {
      this.$store.dispatch("alert/warning", "failed to publish form");
      return;
    }

    const form = requestBody[0];
    form.status = 3;
    this.publishing = true;
    await this.$store.dispatch("question/updateForm", form);
    this.publishing = false;
    this.confirmPublish = !this.confirmPublish;
  }

  get employees(): Employee[] {
    const self = selfData();
    const empls =
      this.departmentID === 0
        ? _.orderBy(
            _.filter(
              this.$store.state.directory.employees ?? [],
              (employee: Employee) => employee.id !== self.id,
            ),
            employee => employee.firstName.toLowerCase(),
          )
        : _.orderBy(
            _.filter(
              this.$store.state.directory.employees ?? [],
              (employee: Employee) =>
                employee.id !== self.id &&
                employee.primaryDepartmentId === this.departmentID,
            ),
            employee => employee.firstName.toLowerCase(),
          );
    return empls.map((employee: Employee) => {
      return {
        ...employee,
        list: `${employee.firstName} ${employee.lastName} - ${employee.title} - ${employee.departmentAssignments[0].departmentName}`,
      };
    });
  }
}
